import Cookies from 'js-cookie'

// const TokenKey = 'cp-token'
const TokenKey = 'cp-token'

export function getToken() {
  // return Cookies.get(TokenKey)
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function isLogin() {
  return getToken() ? true : false;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js